import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { TabPanelProps } from "../../screens/Tabs.MUI/Tabs.interface";
import DG from "./../DataGrid/DataGrid";
import { useNavigate } from "react-router-dom";
import { Div } from "src/screens/Tabs.MUI/tabs.styled";
import { ToastContainer } from "react-toastify";
import General from "../../stores/GeneralStore";
import SearchIcon from "../../assets/search-icon.svg";

import { observer } from "mobx-react";
import { Modal } from "@mui/material";
import NewRequest from "./NewRequest";
import paymentReceiptsStore from "../../stores/PaymentReceiptsStore";
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  const contrast = General?.contrast;

  return (
    <div
      style={{
        width: "100%",
      }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            p: 3,
            padding: 0,
            backgroundColor: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "",
            color: contrast?.contrastColor ? contrast?.contrastColor : "",
          }}
        >
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
interface Obj {
  setValue: any;
  value: any;
}
const PaymentTabs = (props: Obj) => {
  const { setValue, value } = props;
  const navigate = useNavigate();

  const [filter, setFilter] = React.useState<string | null>(null);
  const [selectFilter, setSelectFilter] = React.useState({
    payment: "all",
    account: "all",
  });
  const [newRequest, setNewRequest] = React.useState(false);
  // console.log("value", value);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(event.target.value);
  };

  React.useEffect(() => {
    setFilter(null);
    setSelectFilter({ payment: "all", account: "all" });
  }, [value]);

  const handlePSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectFilter((old) => {
      return {
        ...old,
        payment: e.target.value,
      };
    });
  };
  const [pendingfilter, setPendinfilter] = React.useState<any>()
  const handleASelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    // paymentReceiptsStore?.resetPendingPayments();
    setSelectFilter((old) => {
      return {
        ...old,
        account: e.target.value,
      };
    });
    // setPendinfilter(e.target.value)
    // setSelectFilter((prevSelectFilter) => ({
    //   ...prevSelectFilter,
    //   account: e.target.value,
    // }));
  };
  const setColorContrastClass = (valueID: number, textClass: string, contrastColor: string) => {
    return textClass === null ?
      value === valueID ? // null
        (contrastColor === "" || typeof (contrastColor) === 'undefined') ? textClass === 'greenText' ? 'selectedInnerTabGreen' : 'innerTab' || 'whiteText' : contrastColor === 'yellow' ? "yellowText selectedInnerTabYellow" : "limeText selectedInnerTabLime"//active tab
        : (contrastColor === "" || typeof (contrastColor) === 'undefined') ? textClass === 'greenText' ? 'not-selectedGreen' : '' : contrastColor === 'yellow' ? "blueText selectedInnerTabBlue" : "blackText "// non active tab
      : value === valueID ? // !null
        contrastColor === "" || typeof (contrastColor) === 'undefined' ? textClass === 'greenText' ? 'selectedInnerTabGreen' : 'selectedInnerTabBlack' || 'whiteText' : contrastColor === 'yellow' ? "yellowText selectedInnerTabYellow" : "limeText selectedInnerTabLime"//active tab
        : contrastColor === "" || typeof (contrastColor) === 'undefined' ? textClass === 'greenText' ? 'not-selectedGreen' : 'not-selectedBlack' : contrastColor === 'yellow' ? "blueText not-selectedYellow" : "blackText not-selectedLime"// non active tab

  }
  const navigateToPaymentPlan = () => {
    navigate("/payment-plan");
  };

  const [isLargeScreen, setIsLargeScreen] = React.useState(false);

  React.useEffect(() => {
    function handleResize() {
      setIsLargeScreen(window.innerWidth > 991);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

  return (
    <Box sx={{ width: "100%", height: isLargeScreen ? "100vh" : "84vh" }}>
      {/* <ToastContainer/> */}

      <Box
        sx={{
          color: contrast?.contrastColor ? contrast?.contrastColor : "",
          paddingLeft:
            General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode != "ARA"
              ? "80px"
              : "",
          paddingRight:
            General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA"
              ? "80px"
              : "",
          backgroundColor: "",
          "@media screen and (max-width: 768px)": {
            paddingLeft: "0", // Adjust padding for smaller screens if needed
            paddingRight: "0", // Adjust padding for smaller screens if needed
          },
        }}
      >
        <Tabs
          className="paymentTabs"
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{ width: "100%" }}
          variant="scrollable"
          TabIndicatorProps={{
            style: {
              display: "none",
            },
          }}
          allowScrollButtonsMobile
        >
          <Tab
            label={
              <span
                style={{
                  fontSize: `${isLargeScreen ? 0.8 : 0.8 * General.accessibility.fontSize
                    }rem`,
                  fontWeight: 700,
                }}
              //className={General?.textClass? value !== 0? "whiteText":"blackText":""}
              >
                {General?.codeLabels["cm_dash_pending"]?.label
                  ? General?.codeLabels["cm_dash_pending"]?.label
                  : "Pending Payments"}
              </span>
            }
            {...a11yProps(0)}
            className={setColorContrastClass(0, General?.textClass, General.contrast.contrastColor)}

            sx={{
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : "#101E8E",
              zIndex: "0",
              "&.Mui-selected": {
                outline: "none",
                width:"15%"
              },
            }}
          />
          <Tab
            label={
              <span
                style={{
                  fontSize: `${isLargeScreen ? 0.8 : 0.8 * General.accessibility.fontSize
                    }rem`,
                  fontWeight: 700,
                }}
              //className={General?.textClass? value !== 1? "whiteText":"blackText":""}
              >
                {General?.codeLabels["cm_payment_billhistory"]?.label
                  ? General?.codeLabels["cm_payment_billhistory"]?.label
                  : "BILLS HISTORY"}
              </span>
            }
            {...a11yProps(1)}
            className={setColorContrastClass(1, General?.textClass, General.contrast.contrastColor)}
            sx={{
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : "#101E8E",
              marginLeft: "2px",
              zIndex: "0",
              "&.Mui-selected": {
                outline: "none",
              },
              width:"15%"
            }}
          />
          <Tab
            label={
              <span
                style={{
                  fontSize: `${isLargeScreen ? 0.8 : 0.8 * General.accessibility.fontSize
                    }rem`,
                  fontWeight: 700,
                }}
              //className={General?.textClass? value !== 2? "whiteText":"blackText":""}
              >
                {General?.codeLabels["cm_payment_paymenthistory"]?.label
                  ? General?.codeLabels["cm_payment_paymenthistory"]?.label
                  : "PAYMENT HISTORY"}
              </span>
            }
            {...a11yProps(2)}
            className={setColorContrastClass(2, General?.textClass, General.contrast.contrastColor)}
            sx={{
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : "#101E8E",
              marginLeft: "2px",
              zIndex: "0",
              "&.Mui-selected": {
                outline: "none",
              },
              width:"15%"
            }}
          />
          <Tab
            label={
              <span
                style={{
                  fontSize: `${isLargeScreen ? 0.8 : 0.8 * General.accessibility.fontSize
                    }rem`,
                  fontWeight: 700,
                }}
              //className={General?.textClass? value !== 3? "whiteText":"blackText":""}
              >
                {General?.codeLabels["cm_payment_chequ"]?.label
                  ? General?.codeLabels["cm_payment_chequ"]?.label
                  : "POST DATED CHEQUES"}
              </span>
            }
            {...a11yProps(3)}
            className={setColorContrastClass(3, General?.textClass, General.contrast.contrastColor)}
            sx={{
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : "#101E8E",
              marginLeft: "2px",
              zIndex: "0",
              "&.Mui-selected": {
                outline: "none",
              },
              width:"15%"
            }}
          />
          <Tab
            label={
              <span
                style={{
                  fontSize: `${isLargeScreen ? 0.8 : 0.8 * General.accessibility.fontSize
                    }rem`,
                  fontWeight: 700,
                }}
              //className={General?.textClass? value !== 4? "whiteText":"blackText":""}
              >
                {General.codeLabels["cm_summarytabtitle"]?.label
                  ? General?.codeLabels["cm_summarytabtitle"]?.label
                  : "Account Summary"}
              </span>
            }
            {...a11yProps(3)}
            className={setColorContrastClass(4, General?.textClass, General.contrast.contrastColor)}
            sx={{
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : "#101E8E",
              marginLeft: "2px",
              zIndex: "0",
              "&.Mui-selected": {
                outline: "none",
              },
              width:"15%"
            }}
          />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <DG
          index={0}
          checkboxSelection={true}
          filter={filter}
          selectFilter={selectFilter}
          children={
            <div
              className={`${isLargeScreen ? "d-flex" : "d-flex justify-content-between"
                }`}
            >

              <select
                onChange={handleASelectChange}
                defaultValue={"all"}
                style={{
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : ColorAss,
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#E5EFF2",
                  /*marginLeft: '1rem',*/ width: isLargeScreen
                    ? "18rem"
                    : "50%",
                  height: "2.5rem",
                  marginLeft: "17px",
                  fontSize: isLargeScreen
                    ? `${General.accessibility.fontSize}rem`
                    : `${0.625 * General.accessibility.fontSize}rem`,
                  marginRight: '17px'
                }}
              >
                <option value={"all"}>
                  {General?.codeLabels["cm_payment_allaccount"]?.label
                    ? General?.codeLabels["cm_payment_allaccount"]?.label
                    : "All Account"}
                </option>
                <option value={"Default Account"}>
                  {General?.codeLabels["cm_as_actype_default"]?.label
                    ? General?.codeLabels["cm_as_actype_default"]?.label
                    : "Service Charges Account For Owner"}
                </option>
                <option value={"Connector Account"}>
                  {General?.codeLabels["cm_as_actype_connector"]?.label !== undefined
                    ? General?.codeLabels["cm_as_actype_connector"]?.label
                    : "Connection Fees Account"}
                </option>
                <option value={"UOS"}>
                  {General?.codeLabels["cm_as_actype_uos"]?.label !== undefined
                    ? General?.codeLabels["cm_as_actype_uos"]?.label
                    : "Service Charges Account For Tenant"}
                </option>
              </select>
            </div>
          }
          children2={
            <Box
              className=" "
              sx={{
                display: "flex",
                flex: 1,
                gap: "1rem",
                height: "2.5rem",
                width: "22.5rem",
                "@media screen and (max-width: 768px)": {
                  width: "100%",
                },
              }}
            >
              <input
                className="searchButton w-100"
                onChange={handleSearchChange}
                type={"text"}
                placeholder={
                  General?.codeLabels["cm_search"]?.label
                    ? General?.codeLabels["cm_search"]?.label
                    : "Search"
                }
                style={{
                  flex: 2,
                  paddingLeft: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '40px' : '10px',
                  paddingRight: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '10px' : '40px', // Adjust the padding to make space for the icon
                  height: "40px",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : ColorAss,
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#E5EFF2",
                  backgroundImage: `url(${SearchIcon})`, // Set the background image
                  backgroundPosition: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? 'left 10px center' : 'right 10px center', // Adjust the position of the icon
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "20px 20px", // Adjust the size of the icon
                }}
              />
            </Box>
          }
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <DG
          OtherWidth="96%"
          index={1}
          filter={filter}
          selectFilter={selectFilter}
          children2={
            <Box
              sx={{
                display: "flex",
                gap: "1rem",
                "@media screen and (max-width: 768px)": {
                  flexDirection: "column",
                },
              }}
            >
              {/* <select
                onChange={handlePSelectChange}
                defaultValue={selectFilter.payment}
                style={{
                  height: "40px",
                  width: isLargeScreen ? "168px" : "100%",
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : ColorAss,
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#E5EFF2",
                  fontSize: `${General.accessibility.fontSize}rem`,
                }}
              >
                <option value={"all"}>
                  {General?.codeLabels["cm_payment_allpayment"]?.label
                    ? General?.codeLabels["cm_payment_allpayment"]?.label
                    : "All Payments"}
                </option>
                <option value={"Due"}>
                  {General?.codeLabels["cm_due"]?.label
                    ? General?.codeLabels["cm_due"]?.label
                    : "Due"}
                </option>
                <option value={"Paid"}>
                  {General?.codeLabels["cm_paid"]?.label
                    ? General?.codeLabels["cm_paid"]?.label
                    : "Paid"}
                </option>
                <option value={"Paid Partially"}>
                  {General?.codeLabels["cm_paid_partially"]?.label
                    ? General?.codeLabels["cm_paid_partially"]?.label
                    : "Paid Partially"}
                </option>
              </select> */}

              <input
                className="searchButton2"
                onChange={handleSearchChange}
                type={"text"}
                placeholder={General?.codeLabels["cm_search"]?.label ? General?.codeLabels["cm_search"]?.label : "Search"}
                style={{
                  width: isLargeScreen ? "276px" : "100%",
                  paddingLeft: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '40px' : '10px',
                  paddingRight: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '10px' : '40px', // Adjust the padding to make space for the icon
                  height: "40px",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : ColorAss,
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "",
                  backgroundImage: `url(${SearchIcon})`, // Set the background image
                  backgroundPosition: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? 'left 10px center' : 'right 10px center', // Adjust the position of the icon
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "20px 20px", // Adjust the size of the icon
                }}
              />
            </Box>
          }
        />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <DG
          index={2}
          filter={filter}
          selectFilter={selectFilter}
          children2={
            <Box
              sx={{
                display: "flex",
                gap: "1rem",
                "@media screen and (max-width: 768px)": {
                  flexDirection: "column",
                },
              }}
            >

              <input
                className="searchButton2"
                onChange={handleSearchChange}
                type={"text"}
                placeholder={
                  General?.codeLabels["cm_search"]?.label
                    ? General?.codeLabels["cm_search"]?.label
                    : "Search"
                }
                style={{
                  width: isLargeScreen ? "276px" : "100%",
                  paddingLeft: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '40px' : '10px',
                  paddingRight: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '10px' : '40px', // Adjust the padding to make space for the icon
                  height: "40px",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : ColorAss,
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#E5EFF2",
                  backgroundImage: `url(${SearchIcon})`, // Set the background image
                  backgroundPosition: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? 'left 10px center' : 'right 10px center', // Adjust the position of the icon
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "20px 20px", // Adjust the size of the icon
                }}
              />
            </Box>
          }
        />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <DG
          OtherWidth="96%"
          index={3}
          filter={filter}
          selectFilter={selectFilter}
          children2={
            <div
              style={{
                display: isLargeScreen ? "flex" : "block",
                gap: "1rem",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" }, // Change to column below xs (768px)
                  gap: {
                    xs: "20px",
                    md: "10px",
                  },
                }}
              >
                <select
                  onChange={handlePSelectChange}
                  defaultValue={selectFilter.payment}
                  style={{
                    height: "40px",
                    width: isLargeScreen ? "168px" : "100%",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : ColorAss,
                    background: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "#E5EFF2",
                  }}
                >
                  <option value={"all"}>
                    {General?.codeLabels["cm_payment_allpayment"]?.label
                      ? General?.codeLabels["cm_payment_allpayment"]?.label
                      : "All Payments"}
                  </option>

                  {/* <option value={"Paid"}>
                    {General?.codeLabels["cm_paid"]?.label
                      ? General?.codeLabels["cm_paid"]?.label
                      : "Paid"}
                  </option>
                  <option value={"Paid Partially"}>
                    {General?.codeLabels["cm_paid_partially"]?.label
                      ? General?.codeLabels["cm_paid_partially"]?.label
                      : "Paid Partially"}
                  </option> */}
                </select>
                <input
                  className="searchButton2"
                  onChange={handleSearchChange}
                  type={"text"}
                  placeholder={General?.codeLabels["cm_search"]?.label ? General?.codeLabels["cm_search"]?.label : "Search"}
                  style={{
                    width: isLargeScreen ? "276px" : "100%",
                    paddingLeft: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '40px' : '10px',
                    paddingRight: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '10px' : '40px', // Adjust the padding to make space for the icon
                    height: "40px",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : ColorAss,
                    background: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "#E5EFF2",
                    backgroundImage: `url(${SearchIcon})`, // Set the background image
                    backgroundPosition: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? 'left 10px center' : 'right 10px center', // Adjust the position of the icon
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "20px 20px", // Adjust the size of the icon
                  }}
                />
              </Box>

              {/* <button
                onClick={navigateToPaymentPlan}
                className="mt-lg-0 mt-2"
                style={{
                  position: "relative",
                  border: "none",
                  width: isLargeScreen ? "250px" : "100%",
                  padding: "10px",
                  fontFamily: "Segoe UI",
                  height: isLargeScreen ? "40px" : "55px",

                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  lineHeight: "20px",
                  color: General.contrast.contrastColor
                    ? General.contrast.contrastBackground
                    : '#fff',
                  background: General.contrast.contrastBackground
                    ? General.contrast.contrastColor
                    : General?.ColorAss,
                }}
              >
                {General?.codeLabels["cm_req_for_pay"]?.label
                  ? General?.codeLabels["cm_req_for_pay"]?.label
                  : "REQUEST FOR PAYMENT PLAN"}
              </button> */}
            </div>
          }
        />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <DG
          index={4}
          filter={filter}
          // selectFilter={selectFilter}
          children2={
            <Box
              className="d-flex align-items-end"
              sx={{
                display: "flex",
                gap: "1rem",
                marginTop: "-40px",
                "@media screen and (max-width: 768px)": {
                  flexDirection: "column",
                },
              }}
            >
              <input
                className="searchButton2 "
                onChange={handleSearchChange}
                type={"text"}
                placeholder={General?.codeLabels["cm_search"]?.label ? General?.codeLabels["cm_search"]?.label : "Search"}
                style={{
                  width: isLargeScreen ? "276px" : "100%",
                  paddingLeft: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '40px' : '10px',
                  paddingRight: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '10px' : '40px', // Adjust the padding to make space for the icon
                  height: "40px",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : ColorAss,
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#E5EFF2",
                  backgroundImage: `url(${SearchIcon})`, // Set the background image
                  backgroundPosition: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? 'left 10px center' : 'right 10px center', // Adjust the position of the icon
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "20px 20px", // Adjust the size of the icon
                }}
              />
              <button
                onClick={() => setNewRequest(true)}
                className="mt-lg-0 mt-2 "
                style={{
                  position: "relative",
                  border: "none",
                  width: isLargeScreen ? "200px" : "100%",
                  padding: "8px",
                  height: isLargeScreen ? "40px" : "55px",
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  lineHeight: "20px",
                  color: General.contrast.contrastColor
                    ? General.contrast.contrastBackground
                    : '#fff',
                  background: General.contrast.contrastBackground
                    ? General.contrast.contrastColor
                    : General?.ColorAss,
                  zIndex: 0,
                  textTransform: 'uppercase'
                }}
              >
                {General?.codeLabels["cm_as_label_addbtn"]?.label
                  ? General?.codeLabels["cm_as_label_addbtn"]?.label
                  : "New Request"}
              </button>
            </Box>
          }
        />
      </TabPanel>
      <Modal sx={{ '--bg-color': ColorAss ? ColorAss : 'pink' }} open={newRequest} onClose={() => setNewRequest(false)}>
        <NewRequest onClose={() => {
          setFilter('')
          setNewRequest(false)
        }} />
      </Modal>
    </Box>
  );
};
export default observer(PaymentTabs);
